import { render, staticRenderFns } from "./symptomlist.vue?vue&type=template&id=79b2a74a&scoped=true"
import script from "./symptomlist.vue?vue&type=script&lang=js"
export * from "./symptomlist.vue?vue&type=script&lang=js"
import style0 from "./symptomlist.vue?vue&type=style&index=0&id=79b2a74a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79b2a74a",
  null
  
)

export default component.exports